export const recognitionQueryKeys = {
  months: () => ["eex-recognition-months"] as const,
};

export function buildRecognitionMonthsRequestPath(): string {
  return "/eex/recognition/months";
}
